export default __webpack_public_path__ + "static/media/cancel-white.c2b05bf6.svg";